import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PhoneNumberSheetComponent } from '@sc/ui-components';
import { PhoneNumberOutputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-phone-number-dialog',
  styleUrls: ['./phone-number-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [PhoneNumberSheetComponent],
  template: `
    <sc-phone-number-sheet
      (phoneNumberResult)="onCloseSheet($event)"
    ></sc-phone-number-sheet>
  `,
})
export class PhoneNumberDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      PhoneNumberDialogComponent,
      PhoneNumberOutputData
    >
  ) {}

  onCloseSheet(data?: PhoneNumberOutputData) {
    this.dialogRef.close(data);
  }
}
